import React, { useEffect, useState } from 'react';
import JDMAVue from './JDMAVue';
import JDMASuiviVN from './JDMASuiviVN';
import JDMADashboard from './JDMADashboard';
import JDMAAnalyseIA from './JDMAAnalyseIA';
import SatisfactionCampagne from './SatisfactionCampagne';
import { loadPeriodFilter, savePeriodFilter } from '../utils/jdmaPeriod';

function JDMAPage({ user, concessions = [], editMode = false }) {
  const [tab, setTab] = useState('apv');
  const [periodFilter, setPeriodFilter] = useState(loadPeriodFilter);
  const isSuperAdmin = user?.role === 'super-admin';

  useEffect(() => {
    savePeriodFilter(periodFilter);
  }, [periodFilter]);

  return (
    <div className="page-container">
      <div className="page-tabs">
        <button className={tab === 'apv' ? 'active' : ''} onClick={() => setTab('apv')}>
          🔧 Avis APV
        </button>
        <button className={tab === 'vn' ? 'active' : ''} onClick={() => setTab('vn')}>
          🚗 Avis Ventes VN
        </button>
        <button className={tab === 'suivi-vn' ? 'active' : ''} onClick={() => setTab('suivi-vn')}>
          📞 Suivi VN
        </button>
        <button className={tab === 'dashboard' ? 'active' : ''} onClick={() => setTab('dashboard')}>
          📊 Tableau de bord
        </button>
        {isSuperAdmin && (
          <button className={tab === 'analyse-ia' ? 'active' : ''} onClick={() => setTab('analyse-ia')}>
            🤖 Analyse IA<span className="tab-sa-lock" title="Visible par les super-admins uniquement">🔒</span>
          </button>
        )}
        {isSuperAdmin && (
          <button className={tab === 'campagnes' ? 'active' : ''} onClick={() => setTab('campagnes')}>
            📣 Campagnes SMS<span className="tab-sa-lock" title="Visible par les super-admins uniquement">🔒</span>
          </button>
        )}
      </div>

      {(tab === 'apv' || tab === 'vn') && (
        <JDMAVue
          type={tab}
          user={user}
          concessions={concessions}
          periodFilter={periodFilter}
          setPeriodFilter={setPeriodFilter}
        />
      )}
      {/* Le tableau de bord porte ses propres filtres (période, segment,
          concession, établissement) : il ne partage pas `periodFilter` avec les
          onglets Avis, dont la période ne pilote pas les mêmes blocs. */}
      {tab === 'dashboard' && (
        <JDMADashboard concessions={concessions} />
      )}
      {tab === 'suivi-vn' && (
        <JDMASuiviVN
          user={user}
          concessions={concessions}
          periodFilter={periodFilter}
          setPeriodFilter={setPeriodFilter}
        />
      )}
      {/* Double garde : un `tab` résiduel ne doit pas exposer le contenu si le
          rôle change (retour d'une impersonation, par exemple). */}
      {tab === 'analyse-ia' && isSuperAdmin && (
        <JDMAAnalyseIA user={user} concessions={concessions} editMode={editMode} />
      )}
      {tab === 'campagnes' && isSuperAdmin && (
        <SatisfactionCampagne />
      )}
    </div>
  );
}

export default JDMAPage;
